import moment from 'moment';
import axios from 'axios';


function errorResponseHandler(error) {
	// check for errorHandle config
	if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
		return Promise.reject(error);
	}

	// if has response show the error
	if (error.response) {
		if (error.response.statusText) {
			window.emitter.$emit('showToastMessage', {
				msg: error.response.statusText,
				type: 'error'
			});
			if (error.response.status === 401) {
				window.location.href = 'login';
			}
		}
	}
}

// apply interceptor on response
axios.interceptors.response.use(
	response => response,
	errorResponseHandler
);


export function getData(url, method = 'POST') {
	var data = {};
	const token = localStorage.getItem('b');
	saveTimestamp();
	if (token) {
		data.b = token;
	}

	// Get the data
	var xhrPromise = new Promise(
		function (resolve, reject) {
			return axios.post(url, JSON.stringify(data)).then(function (response) {
				if (response.data) {
					resolve(response && response.data)
				} else {
					reject();
				}
			}).catch(error => {

			});
		}
	)

	return xhrPromise;

}

export function fetchData(url, method = 'POST') {
	var data = {};
	const token = localStorage.getItem('b');
	saveTimestamp();
	if (token) {
		data.b = token;
	}

	var myInit = {
		method: method,
		mode: 'cors',
		cache: 'default'
	};

	if (method === 'POST') {
		myInit['body'] = JSON.stringify(data);
	}

	return fetch(url, myInit).then(function (response) {
			var contentType = response.headers.get("content-type");

			if (response.status === 401) {
				window.location = '#/logout';
				return {
					data: null
				};
			}

			if (contentType && contentType.includes("application/json")) {
				return response.json();
			}
			throw new TypeError("Oops, we haven't got JSON!");
		})
		.then(function (json) {
			return json
		})
		.catch(function (error) {
			console.log(error);
		});
}

export function setData(url, data) {

	const token = localStorage.getItem('b');
	saveTimestamp();

	if (token) {
		data.b = token;
	}

	// Get the data
	var xhrPromise = new Promise(
		function (resolve, reject) {
			axios.post(url, JSON.stringify(data)).then(function (response) {
				if (response && response.data) {
					resolve(response.data)
				} else {
					reject();
				}
			})
		}
	)
	return xhrPromise;
}

export function getFormattedDate(date, showHours) {
	return date ? moment(date).format('DD-MM-YYYY' + (showHours ? ' HH:mm' : '')) : '';
}


export function getFormattedAmount(amount) {
	if (amount) {
		amount = parseFloat(amount).toFixed(2);
		amount = String(amount);
		return amount.replace('.', ',');
	} else {
		return '';
	}
}

export function getDayDescription(date, checkIfToday) {
	let days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag']
	var momentDate = moment(date);
	if (checkIfToday) {
		var iscurrentDate = momentDate.isSame(new Date(), "day");
		if (iscurrentDate) {
			return 'Vandaag'
		}
	}

	const day = momentDate.weekday();
	return days[day]
}

export function getUnitImage(unitId) {
	return window.baseUrl + 'uploads/' + unitId + '.jpg?id=' + Date.now();
}

export function getPaidOptions() {
	return [
		{
			text: 'Openstaand',
			value: '0'
		},
		{
			text: 'iDeal',
			value: '1'
		},
		{
			text: 'Overschrijving',
			value: '2'
		},
		{
			text: 'Contant',
			value: '3'
		},
		{
			text: 'Verrekend met borg',
			value: '4'
		}
	]
}


export function getPaidDescriptions() {
	return [
		{
			text: 'Controleer',
			value: '-1'
		},{
			text: 'Openstaand',
			value: '0'
		},
		{
			text: 'iDeal',
			value: '1'
		},
		{
			text: 'Overschrijving',
			value: '2'
		},
		{
			text: 'Contant',
			value: '3'
		},
		{
			text: 'Verrekend met borg',
			value: '4'
		}
	]
}

export function setPlaceHolder(unit) {
	unit.img_small = "http://www.carmag.co.za/carmag/wp-content/themes/car_mag/public/img/placeholder-291x382.png";
}
export function getMonths(showOnlyOccured) {
	var maandArray = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
	if (showOnlyOccured) {
		var d = new Date();
		var n = d.getMonth();
		return maandArray.slice(0, n + 1);
	} else {
		return maandArray;
	}
}
export function getMonth(index) {
	var maandArray = getMonths();
	return maandArray[index];
}

export function getSettings(key) {
	var settingsJson = localStorage.getItem('settings');
	var settings = {};
	if (!settingsJson) {

		settings = {
			animation: 'scale-transition'
		}
	} else {
		settings = JSON.parse(settingsJson);
	}

	if (key) {
		return settings[key];
	} else {
		return settings;
	}
}

export function getTimestamp() {
	return new Date().getTime();
}

function getSavedTimestamp() {
	return localStorage.getItem('ats');
}

function saveTimestamp() {
	if (getTimestamp() - getSavedTimestamp() > 60000) {
		localStorage.setItem('ats', getTimestamp());
		console.log('ts saved');
	}
}

export function getFullDate(selectedDate) {
	return (
		moment(selectedDate).format("DD-MM-YYYY") +
		" (" +
		getDayDescription(selectedDate) +
		")"
	);
}

export function saveSettings(settings) {
	var settings = localStorage.setItem('settings', JSON.stringify(settings));
}

export function checkEmailAddress(email) {
	return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

export function capitalizeFirstLetter(string) {
	if (string.search(/ /) <= 0) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	} else {
		return string.charAt(0).toLowerCase() + string.slice(1);
	}
}



// WEBPACK FOOTER //
// ./src/utils/utils.js